import styled from 'styled-components';

const H3 = styled.h3`
  color: #3e465b;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
  margin: 25px 50px 15px;
`;

export default H3;